'use client';
import CTA from '@/components/ui/CTA';
import '@/styles/components/library/section.css';

const Section = ({id='section', modifier, focus="", headline, sub, img, text, nested, cta, url}) => {
  return (
    <section id={id} className={`section ${modifier} ${focus}`}>
      <div className={`${id}__content`}>
        {headline && (
        <div className="section__heading">
          <h2>{headline}</h2>
        </div>
        )}

        {sub &&
          <div className="section__text">
            <p>{sub}</p>
          </div>
        }

        {img &&
          <img src={img.url} alt={img.alt} />
        }

        {text && 
          <>{text}</>
        }
        
        {nested}

        {cta && url &&
          <CTA type="link" text={cta} url={url} />
        }
      </div>
    </section>
  );
}

export default Section;
